import { Box } from 'components/Box';
import { Flex } from 'components/Flex';
import { GenericCheckbox } from 'components/GenericCheckbox';
import { MetaDataChoice } from 'types/api/envScales/MetaDataChoice';
import { ItemWrapper, CheckedSquare, NotCheckedSquare } from './Styled';
import { OptionValue } from './utils';

export interface MetaDataCheckBoxProps {
  /** Meta data choice. */
  choice: MetaDataChoice;

  /** Meta data option value. */
  value: OptionValue;

  /** Callback fired when the value changes. */
  onChange: (data: { name: string; value: OptionValue }) => void;
}

export function MetaDataCheckBox({
  choice,
  value,
  onChange
}: MetaDataCheckBoxProps) {
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const isChecked = event.target.checked;

    if (isChecked) {
      onChange({ name: choice.t_name, value: { ...value, isChecked } });
    } else {
      onChange({
        name: choice.t_name,
        value: { isChecked, choiceId: choice.id, isPrimary: false }
      });
    }
  }

  return (
    <ItemWrapper>
      <Flex align="center">
        <GenericCheckbox
          aria-label={choice.name}
          onChange={handleChange}
          checked={value.isChecked}
          type="checkbox"
        >
          {value.isChecked ? <CheckedSquare /> : <NotCheckedSquare />}
        </GenericCheckbox>
        <Box as="span" ml="16px">
          {choice.name}
        </Box>
      </Flex>
    </ItemWrapper>
  );
}
